import { render, staticRenderFns } from "./CardImages.vue?vue&type=template&id=2374b206&"
import script from "./CardImages.vue?vue&type=script&lang=js&"
export * from "./CardImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports